import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from '../base/base.service';
import {Stockroom} from '../../models/stockroom/stockroom';
import {Query} from '../../models/query/query';
import {WebMethodResult} from '../../models/web-method-result';
import {AppModulePath} from '../../models/app-module-path';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class StockroomService extends BaseService {

  private listUrl = '/api/stockroom/list';
  private listAllUrl = '/api/stockroom/listAll';
  private listAllowedUrl = '/api/stockroom/listAllowed';
  private listAllowedProjectsUrl = '/api/stockroom/listAllowedProjects';
  private listByCompanyIdUrl = '/api/stockroom/listByCompanyId';
  private saveUrl = '/api/stockroom/save';
  private deleteUrl = '/api/stockroom/delete/';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<Stockroom[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Stockroom[]>(url, AppModulePath.STOCKROOM).pipe(
      map(res => res.map(obj => new Stockroom(obj))),
      catchError(this.handleError));
  }

  listAll(qry: Query): Observable<Stockroom[]> {
    const url = this.listAllUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Stockroom[]>(url, AppModulePath.STOCKROOM).pipe(
      map(res => res.map(obj => new Stockroom(obj))),
      catchError(this.handleError));
  }

  listAllowed(): Observable<Stockroom[]> {
    return this.post<Stockroom[]>(this.listAllowedUrl, AppModulePath.STOCKROOM, '').pipe(
      map(res => res.map(obj => new Stockroom(obj))),
      catchError(this.handleError));
  }

  listAllowedProjects(): Observable<Stockroom[]> {
    return this.post<Stockroom[]>(this.listAllowedProjectsUrl, AppModulePath.STOCKROOM, '').pipe(
      map(res => res.map(obj => new Stockroom(obj))),
      catchError(this.handleError));
  }

  listByCompanyId(qry: Query): Observable<Stockroom[]> {
    const url = this.listByCompanyIdUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Stockroom[]>(url, AppModulePath.STOCKROOM).pipe(
      map(res => res.map(obj => new Stockroom(obj))),
      catchError(this.handleError));
  }

  save(stockroom: Stockroom): Observable<Stockroom> {
    return this.post<Stockroom>(this.saveUrl, AppModulePath.STOCKROOM, stockroom).pipe(
      map(res => new Stockroom(res)),
      catchError(this.handleError));
  }

  delete(id: string): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.STOCKROOM).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }
}
